import { SectionPill, SuiteToggle, SuiteTab } from "../shared";
import { ExecutionToolkit } from "../executionToolkit";
import { WorkWithPartner } from "../workWithPartner";

interface SuiteSectionProps {
  tab: SuiteTab;
  onTabChange: (tab: SuiteTab) => void;
}

const SuiteSection: React.FC<SuiteSectionProps> = ({ tab, onTabChange }) => {
  return (
    <section className="bg-white py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-[1070px] mx-auto">
        {/* Resources label + toggle */}
        <div className="flex flex-col items-center text-center gap-6">
          <div data-aos="fade-up">
            <SectionPill label="Resources" />
          </div>
          <div data-aos="fade-up" data-aos-delay="100">
            <SuiteToggle tab={tab} onChange={onTabChange} />
          </div>
        </div>

        {/* Switchable content */}
        {tab === "toolkit" ? <ExecutionToolkit /> : <WorkWithPartner />}
      </div>
    </section>
  );
};

export { SuiteSection };
